import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import JwtService from '../../auth/services/jwtService';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

function SignOutPage() {
  const { t } = useTranslation('translations');
  useEffect(() => {
    const timeout = setTimeout(async () => {
      JwtService.logout();

      try {
        await window.connection.stop();
        await window.alarmsConnection.stop();
      } catch (e) {
        console.log(e);
      }

      // to quickly clean redux. NOT RECOMMENDED
      // window.location.href = '/';
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="flex flex-col flex-auto items-center sm:justify-center min-w-0">
      <Paper className="flex items-center w-full sm:w-auto min-h-full sm:min-h-auto rounded-0 py-32 px-16 sm:p-48 sm:rounded-2xl sm:shadow">
        <div className="w-full max-w-320 sm:w-320 mx-auto sm:mx-0">
          <img
            className="w-48 mx-auto"
            src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo.svg`}
            alt="logo"
          />

          <Typography className="mt-32 text-[30px] font-extrabold tracking-tight leading-tight text-center">
            {t('Singout')}
          </Typography>
        </div>
      </Paper>
    </div>
  );
}

export default SignOutPage;
